<template>
	<div>
		<div class="page-title">
			<icon-font class="title-icon" type="icon-yujing" style="margin-right: 12px"/>
			<span>智能预警</span>
    	<a-button class="create-btn" type="primary" @click="addClick">新增</a-button>
			<a-button class="filter-btn btn-tertiary" @click="filterVisible = !filterVisible"> 
        <icon-font type="icon-Filter1"  /><span>筛选</span>
    	</a-button>
		</div>
		<div class="page-filter" v-if="filterVisible">
			<a-form-model ref="form" :model="params">
				<a-form-model-item label="任务名称" prop="taskName">
					<a-input v-model.trim="params.taskName" placeholder="请输入查询条件"></a-input>
				</a-form-model-item>
				<a-form-model-item label="预警状态" prop="warningStatus">
					<a-select v-model.trim="params.warningStatus" placeholder="请输入查询条件">
						<a-select-option :value="1">启用</a-select-option>
						<a-select-option :value="0">禁用</a-select-option>
					</a-select>
				</a-form-model-item>
				<div class="handle-btn">
					<a-button type="primary" @click="search">查询</a-button>
					<a-button @click="reset">重置</a-button>
				</div>
			</a-form-model>
		</div>
		<div class="page-table">
      <vxe-grid
        border="inner"
        :columns="columns"
        auto-resize
        :column-config="{resizable: true}"
        :row-config="{isCurrent: true, isHover: true}"
        id="id"
        :data="data"
        show-overflow
        :empty-render="{name: 'NotData'}"
        size="small"
        :loading="loading"
			>
				<template #warningStatus="{row}">
					<a-switch :checked="row.warningStatus === 1" @change="changeStatus(row)" />
				</template>
				<template #handle="{row}">
					<div class="table-handle-btn">
            <a-tooltip placement="top" title="查看">
							<icon-font @click="viewClick(row)" class="view-btn" type="icon-Eye-Open"/>
						</a-tooltip>
            <a-tooltip placement="top" title="编辑">
							<icon-font @click="editClick(row)" class="edit-btn" type="icon-Edit"/>
						</a-tooltip>
					</div>
				</template>
				<template #intelligentMonitorLogNumber="{row}">
					<a-button type="link" @click="logClick(row)">{{row.intelligentMonitorLogNumber}}</a-button>
           <span style="margin-left: -10px;">
            次
            </span>
				</template>
			</vxe-grid>
      <a-pagination
        class="mt-16 mb-16 df-end"
        size="small"
        v-if="(data &&data.length > 0)"
        :pageSize="pagination.pageSize"
        :total="pagination.total"
        :current="pagination.current"
        @change="(page, pageSize) => handleTableChange(page,pageSize)"
      />
		</div>
    <addWarningModal ref="addModal" @success="pagination.current = 1,getList()"></addWarningModal>
    <warningLogModal ref="logModal"></warningLogModal>
	</div>
</template>
<script>
import { intelligentWarningPage, editIntelligentWarning } from '@/api/mediadata'
import addWarningModal from "./components/addWarningModal"
import warningLogModal from "./components/warningLogModal"

const columns = [
	{
		title: '预警任务ID',
		field: 'id',
		// width: 170,
		align: 'left',
	},
	{
		title: '任务名称',
		field: 'taskName',
    ellipsis: true,
		align: 'left',
		// width: 150,
	},
	{
		title: '预警状态',
		field: 'warningStatus',
    slots: { default: 'warningStatus' },		
    align: 'center',
		width: 120,
	},
	{
		title: '数据源',
		field: 'monitorDataSourceName',
		align: 'center',
		width: 120,
	},
	{
		title: '数据层级',
		field: 'monitorDataLevel',
		align: 'center',
		width: 120,
	},
	{
		title: '接收人',
		field: 'warningInformUser',
		align: 'left',
    ellipsis: true,
		width: 170,
	},
	{
		title: '预警日志',
		dataIndex: 'intelligentMonitorLogNumber',
    slots: { default: 'intelligentMonitorLogNumber' },		
    align: 'left',
		// width: 100,
	},
	{
		title: '更新时间',
		field: 'updateTime',
		align: 'left',
		// width: 155,
	},
  {
		title: '操作',
		field: 'handle',
		align: 'left',
    slots: { default: 'handle' },		
    // width: 100,
	},
]
export default {
	name: 'smartWarning',
	data() {
		return {
			activeKey: 'data',
			loading: false,
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10,
        showTotal: total => `共${total}条`
			},
			params: {
				taskName: '',
				warningStatus: undefined
			},
			filterVisible: false,
			data: [],
			columns
		}
	},
	methods: {
		reset() {
			this.$refs.form.resetFields()
			this.pagination.current = 1
			this.getList()
		},
		logClick(record) {
      this.$refs.logModal.init(record)
		},
    addClick() {
			console.log(2)
      this.$refs.addModal.init()
    },
    editClick(record) {
      this.$refs.addModal.init(record)
    },
		// 预览
		viewClick(record) {
      this.$refs.addModal.init(record, true)
		},
		search() {
			console.log(this.params)
			this.pagination.current = 1
			this.getList()
		},
		getList() {
      this.loading = true
      intelligentWarningPage({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        ...this.params
      }).then((res) => {
        this.data = res.data.recordList || []
        this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
		handleTableChange(page) {
      const pager = { ...this.pagination, current:page };
			this.pagination = pager;
      this.getList()
		},
		changeStatus(record) {
			this.loading = true
			editIntelligentWarning({
				warningStatus: record.warningStatus === 1?0:1
			}, record.id).then((res) => {
				this.$message.success(`${record.warningStatus === 1?'禁用':'启用'}成功！`)
				this.getList()
			}).finally(() => this.loading = false)
		}
	},
	mounted() {
		this.getList()
	},
	components: {
		addWarningModal,
		warningLogModal
	}
}
</script>
<style lang="less" scoped>
	.view-btn {
		margin-right: 16px;
	}
	.view-btn,.copy-btn, .edit-btn {
		cursor: pointer;
		font-size: 16px;
		vertical-align: middle;
	}

</style>